import { Commit, Module } from 'vuex'
import { ILandingState } from './types'
import { getLandingData } from '@/api/landing/landing'
import LandingGig from '@/models-ts/landing/LandingGig'
import LandingJob from '@/models-ts/landing/LandingJob'
import LandingVacancy from '@/models-ts/landing/LandingVacancy'
import { RootState } from '@/store'

const getInitialState = (): ILandingState => ({
  jobListPublicData: [],
  gigListPublicData: [],
  vacancyListPublicData: [],
  jobsCount: 0,
  gigsCount: 0,
  vacanciesCount: 0,
})

export default (): Module<ILandingState, RootState> => {
  return {
    namespaced: true,
    state: getInitialState(),
    getters: {
      jobListPublic: (state: ILandingState) => state.jobListPublicData.map(LandingJob.fromServer),
      gigListPublic: (state: ILandingState) => state.gigListPublicData.map(LandingGig.fromServer),
      vacancyListPublic: (state: ILandingState) => state.vacancyListPublicData.slice(0, 8).map(LandingVacancy.fromServer),
      vacancyLinks: (state: ILandingState) => state.vacancyListPublicData.slice(0, 25).map(LandingVacancy.fromServer),
    },
    mutations: {
      setJobListPublicData(state, { items, total }: { items: Array<LX.LandingJob>; total: number }) {
        state.jobListPublicData = items
        state.jobsCount = total
      },
      setGigListPublicData(state: ILandingState, { items, total }: { items: Array<LX.LandingGig>; total: number }) {
        state.gigListPublicData = items
        state.gigsCount = total
      },
      setVacancyListPublicData(state, { items, total }: { items: Array<LX.LandingVacancy>; total: number }) {
        state.vacancyListPublicData = items
        state.vacanciesCount = total
      },
    },
    actions: {
      async getLandingData({ commit }: { commit: Commit }) {
        try {
          const result = await getLandingData(25)
          commit('setJobListPublicData', result.jobs)
          commit('setGigListPublicData', result.gigs)
          commit('setVacancyListPublicData', result.vacancies)
          commit('blog/setLastPostsData', result.blog, { root: true })
        } catch (e) {
          console.log('Error fetching landing data', e)
          commit('setJobListPublicData', { items: [], total: 0 })
          commit('setGigListPublicData', { items: [], total: 0 })
          commit('setVacancyListPublicData', { items: [], total: 0 })
          commit('blog/setLastPostsData', [], { root: true })
        }
      },
    },
  }
}
